import { jsx as o } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as s } from "../../../../external/preact/hooks/dist/hooks.module.js";
import a from "../../DataOverviewDetails/DataOverviewDetails.js";
/* empty css                  */
import { Fragment as i } from "../../../../external/preact/dist/preact.module.js";
const m = {
  base: "adyen-pe-modal-content"
};
function p({ type: r, data: e, ...n }) {
  const t = s(() => {
    switch (r) {
      case "payout":
        return { ...e, type: r };
      case "transaction":
        return { id: e, type: r, ...n };
      default:
        return { data: e, type: r };
    }
  }, [e, r]);
  return /* @__PURE__ */ o(i, { children: t && /* @__PURE__ */ o("div", { className: m.base, children: /* @__PURE__ */ o(a, { ...t }) }) });
}
export {
  p as default
};
